import { ReactComponent as CogIcon } from '../../../../icons/cog-icon.svg';
import { ReactComponent as DownloadIcon } from '../../../../icons/download-icon-new.svg';
import { ReactComponent as LinkIcon } from '../../../../icons/link-icon.svg';
import { ReactComponent as RefreshIcon } from '../../../../icons/icon-refresh.svg';

export const mapButtonToClassName = {
  type: {
    primary: 'integration__button--primary',
    secondary: 'integration__button--secondary',
    error: 'integration__button--error',
  },
  size: {
    small: 'integration__button--small',
    default: 'integration__button--default',
  },
  icon: {
    left: 'integration__button--icon-left',
    right: 'integration__button--icon-right',
  },
  state: {
    true: 'integration__button--disabled',
  },
  spin: {
    true: 'integration__button--icon-spin',
  },
  loader: {
    true: 'integration__button--loader',
  },
};

export const mapTabToClassName = {
  type: {
    primary: 'integration__tab--primary',
    secondary: 'integration__tab--secondary',
  },
  size: {
    small: 'integration__tab--small',
    default: 'integration__tab--default',
  },
  state: {
    true: 'integration__tab--active',
  },
};

export const mapIconToComponent = {
  cog: <CogIcon />,
  download: <DownloadIcon />,
  link: <LinkIcon />,
  refresh: <RefreshIcon />,
};

export const mapListDirectionToClassName = {
  row: 'integration__list--row',
  column: 'integration__list--column',
};

export const mapPaneColorBg = {
  white: 'integration__pane--color-white',
  grey: 'integration__pane--color-grey',
};

export const mapDotClasses = {
  size: {
    small: 'integration__dot--size-small',
    medium: 'integration__dot--size-medium',
  },
  rotate: {
    180: 'integration__dot--rotate-180',
  },
};

export const mapPanePadding = {
  none: 'integration__pane--padding-none',
  0: 'integration__pane--padding-0',
  12: 'integration__pane--padding-12',
};

export const mapHeadlineSize = {
  16: 'integration__headline--size-16',
  24: 'integration__headline--size-24',
};

export const mapDescriptionSize = {
  14: 'integration__description--size-14',
  16: 'integration__description--size-16',
};

export const mapDescriptionColor = {
  black: 'integration__description--color-black',
  grey: 'integration__description--color-grey',
  error: 'integration__description--color-error',
};

export const mapPaneRadius = {
  6: 'integration__pane--radius-6',
  12: 'integration__pane--radius-12',
  20: 'integration__pane--radius-20',
};

export const mapPaneMargin = {
  14: 'integration__pane--margin-14',
  20: 'integration__pane--margin-20',
  40: 'integration__pane--margin-40',
};
